import Vue from 'vue'
import App from './App.vue'


/* Inizio ElementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })
/* Fine ElementUI */
        

/* Inizio TerAs */
var vueData = {}
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'it')
import teras from './teras'
Vue.prototype.$teras = teras
vueData.teras = teras
import axios from './teras/tAxios'
Vue.prototype.$axios = axios
vueData.axios = axios

import './css/big.css'
/* Fine TerAs */
        

/* Inizio Router */
import router from'./router'
/* Fine Router */
        

/* Inizio Storage */
import storage from './teras/tStorage' 
Vue.prototype.$storage = storage
vueData.storage = storage
/* Fine Storage */
        
Vue.config.productionTip = false

/* Inizio TerAs-event */
import aes from './teras/aes'

teras.event.on('autologin', function(to) {
  teras.app.step--

  //aes.password = aes.convertCryptKey('XRF38fFu20ckb2Vu')
  //console.log(encodeURIComponent(aes.encode64(to.params.id,'XRF38fFu20ckb2Vu')))
  //console.log(aes.encode64(to.params.id,'XRF38fFu20ckb2Vu'))
  //console.log(decodeURIComponent(encodeURIComponent(aes.encode64(to.params.id,'XRF38fFu20ckb2Vu'))))
  console.log(aes.decode64(to.params.id,'XRF38fFu20ckb2Vu'))
  //1 is K6VFGBFC+ap913dCbG5jSA== 
  //1 is K6VFGBFC%2Bap913dCbG5jSA%3D%3D
  
  axios.query('fetchRow','SELECT * FROM contatto WHERE email = →email AND id=←id AND centro>0',{email:to.params.email,id:aes.decode64(to.params.id,'XRF38fFu20ckb2Vu')}).then((data) => {
    console.log("LOGIN CHECK AFTER QUERY")
    if(data.result.id > 0){
      teras.utente = data.result
      teras.app.routeInitial = teras.app.routeAuth
      teras.event.emit('login')
    }else{
      teras.app.routeInitial =  '/login'
      teras.app.step++
    }
  }).catch((error) => {
    console.log("ERRORE NELL'INVIO DELLA LOGIN")
    console.log(error.message)
    teras.app.routeInitial =  '/login'
    teras.app.step++
  })
})
teras.event.on('routerFirst', function(to) {
  axios.query('fetchAll',`SELECT variabile.*, LOWER(variabile.nome) AS nome, 1 AS isgruppo FROM variabile WHERE 1 ORDER BY scheda,posizione`,{},teras,'_variabile')  
  axios.query('fetchAll',`SELECT id,parente,CONCAT(IF(parente>0,CONCAT(id,' '),''),nome) AS label FROM anomaliecongenite WHERE 1 ORDER BY id,parente`,{},teras,'_anomaliecongenite')  
  axios.query('fetchAll',`SELECT id,parente,CONCAT(IF(parente>0,CONCAT(id,' '),''),nome) AS label FROM interventichirurgici WHERE 1 ORDER BY id,parente`,{},teras,'_interventichirurgici')  
  axios.query('fetchAll',`SELECT * FROM struttura WHERE id>1 ORDER BY id,nome,tipo`,{},teras,'_struttura')


  axios.query('fetchAll',`SELECT * FROM xmlfiles WHERE 1 ORDER BY filename`,{},teras,'_xmlfiles')
  
  teras.event.emit('centroLoad')
  
  

  axios.query('fetchAll',`SELECT * FROM codicefiscale.provincia WHERE 1 ORDER BY nome`,{},teras,'_provincia')  
  axios.query('fetchAll',`SELECT id,regione AS nome FROM codicefiscale.provincia WHERE regione!='' GROUP BY regione ORDER BY regione`,{},teras,'_regione')  
  axios.query('fetchAll',`SELECT * FROM codicefiscale.nazione WHERE 1 ORDER BY id`,{},teras,'_nazione').then((response) =>  {
    teras.app.step++
  })

  if(to.path=='/registrazione')
    teras.event.emit('logout')

  /* Inizio teras-login */
  console.log("CONTROLLO SE PRESENTE UTENTE IN LOCAL STORAGE....")
  if(storage.exist('utente')){
    console.log("YES, PRESENTE UTENTE IN LOCAL STORAGE....LO RICARICO DA LI..."+to.path)
    teras.utente = storage.load('utente')
    teras.app.routeInitial = (to.matched.some(record => record.meta.requiresAuth)) ? '/login' : to.path
    teras.event.emit('login')
  }else{
      console.log("Aggiungo +1 per il controllo del utente")
      teras.app.step++
      teras.app.routeInitial =  (to.matched.some(record => record.meta.requiresAuth)) ? '/login' : to.path
  }
  /* Fine teras-login */
        
})
teras.event.on('appReady', function() {
console.log("appReady appReady appReady appReady appReady appReady appReady")
router.push(teras.app.routeInitial)
})
teras.event.on('appExit', function() {
})
teras.event.on('centroLoad', function() {
  axios.query('fetchAll',`SELECT centro.*,contatto.cognome AS cntcognome, contatto.nome AS cntnome, contatto.email AS cntemail, contatto.password AS cntpassword, contatto.cellulare AS cntcellulare, struttura.von AS codicevon, struttura.regione, struttura.citta
    ,SUM(IF(nr_numero=0,1,0)) AS schede_completate
    ,SUM(IF(nr_numero<10,1,0)) AS schede_inchiusura
    ,SUM(IF(nr_numero>-1,1,0)) AS schede_inserite
    
    FROM centro 
    LEFT JOIN contatto ON contatto.centro=centro.id 
    LEFT JOIN struttura ON struttura.id = centro.codiceministeriale
    LEFT JOIN paziente ON paziente.centro = centro.id
    WHERE centro.codiceministeriale>1 AND contatto.ruolo=10 GROUP BY centro.id ORDER BY centro.id,centro.nome `,{},teras,'_centro')
})
teras.event.on('pazienteLoad', function() {
  axios.query('fetchAll',`SELECT  * FROM paziente WHERE centro > 10010`,{},teras,'_schede')
  axios.query('fetchAll',`SELECT 
  CASE 
    WHEN nr_numero = 0 THEN 0
    WHEN nr_numero > 0 AND nr_numero <= 10 THEN 10
    WHEN nr_numero > 10 AND nr_numero <= 30 THEN 30
    WHEN nr_numero > 30 AND nr_numero <= 50 THEN 50
    WHEN nr_numero > 50  THEN 100
  END AS esito, COUNT(*) AS totale
  FROM paziente
  WHERE centro > 10010
  GROUP BY 
  esito
  `,{},teras,'_schede_esito')
})
/* Fine TerAs-event */

/* Inizio TerAs-event-login */
teras.event.on('routerNoauth', function() {
})
teras.event.on('login', async () => {
  
  storage.save("utente",teras.utente)
  await centro.profile.load(teras.utente.centro)
  
  console.log("CENTRO IN STEP "+centro.profile.row.step)

  switch(parseInt(centro.profile.row.step)) {
    case 0:
    teras.app.routeInitial = 'login'    
    teras.app.auth = false
    break;
    case 1:
    teras.app.routeInitial = 'centro-profile'   
    teras.app.auth = true 
    break;
    case 2:
    teras.app.routeInitial = 'centro-documenti'    
    teras.app.auth = true
    break;
    case 3:
    teras.app.routeInitial = 'centro-inapprovazione' 
    teras.app.auth = true   
    break;
    case 9:
    teras.app.routeInitial = 'centro'    
    teras.app.auth = true
    break;
    case 10:
    teras.app.routeInitial = 'home'    
    teras.app.auth = true
    break;
    default:
    teras.app.routeInitial = 'page-error'    
  }


  console.log("Aggiungo +1 per il controllo del utente")
  teras.app.step++

  if(teras.app.ready){
    console.log("APPREADYFROM LOGIN "+teras.app.routeInitial)
    router.push(teras.app.routeInitial)
  }
})

teras.event.on('logout', function() {
  teras.utente = {}
  storage.remove('utente')
  centro.profile.row = {}
  teras.app.auth = false
  router.replace('/login')
})
/* Fine TerAs-event-login */
        
import centro from './teras/centro'
Vue.prototype.$centro = centro
vueData.centro = centro       

import nazioni from './teras/nazioni'
Vue.prototype.$nazioni = nazioni
vueData.nazioni = nazioni

new Vue({
  router,
  data:vueData,
  render: h => h(App)
}).$mount('#app')
